import { Badge } from '../ui/badge';

interface TradingStatusBadgeProps {
  status:
    | 'active'
    | 'inactive'
    | 'pending'
    | 'completed'
    | 'failed'
    | 'running'
    | 'stopped'
    | 'open'
    | 'closed'
    | 'approved'
    | 'rejected'
    | 'suspended'
    | 'paused';
}

const TradingStatusBadge = ({ status }: TradingStatusBadgeProps) => {
  const getStatusColor = () => {
    switch (status) {
      case 'active':
      case 'running':
      case 'completed':
      case 'open':
      case 'approved':
        return 'bg-green-100 text-green-800';
      case 'inactive':
      case 'stopped':
      case 'closed':
      case 'suspended':
      case 'paused':
        return 'bg-gray-100 text-gray-800';
      case 'pending':
        return 'bg-yellow-100 text-yellow-800';
      case 'failed':
      case 'rejected':
        return 'bg-red-100 text-red-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };

  return (
    <Badge className={getStatusColor()}>
      {status.charAt(0).toUpperCase() + status.slice(1)}
    </Badge>
  );
};

export default TradingStatusBadge;
